import React from 'react';
import { Redirect, useRouteMatch } from 'react-router';
import { LearnerTrainingStatus } from '~/data';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from './state';
import { firstRequiredSequence } from './state/navigation/requiredPath';
import { isPretestOffered } from './state/pretest/pretest';

const selector = (s: TrainingState) =>
  select(s, 'items', 'highestUnlockedPosition', 'status', 'pretest');

/**
 * Goes to the default sequence for a training, either the last one accessed or the first one.
 */
export const DefaultSequence = () => {
  const { items, highestUnlockedPosition, status, pretest } =
    useTrainingStore(selector);
  const { url } = useRouteMatch();

  if (status === LearnerTrainingStatus.Completed) {
    return <Redirect to={`${url}/success`} />;
  }

  // A pretest the learner has not finished comes before the course.
  if (isPretestOffered(pretest)) {
    return <Redirect to={`${url}/pretest`} />;
  }

  const item =
    items.find(i => i.position === highestUnlockedPosition) ||
    firstRequiredSequence(items) ||
    items.find(i => i.kind === 'sequence');

  if (item && item.kind === 'sequence') {
    return <Redirect to={`${url}/${item.id}`} />;
  }

  throw Error('could not find default sequence');
};
